<template>
	<div class="home">
		<div>
			<NavBar :nav="false" />
			<div class="content">
				<div class="title" v-if="datails?.title">{{ datails?.title }}</div>
				<div class="line" v-if="datails?.title"></div>
				<div class="valueContent">
					<div class="vhtmlBox" v-if="datails?.content" v-html="datails?.content"></div>
					<div v-else class="empty">{{ loading ? '加载中...' : '暂无内容' }}</div>
				</div>
			</div>
			<div class="content" v-if="datails?.advantage">
				<div class="title small">优点</div>
				<div class="valueContent videobox">
					<div class="vhtmlBox" v-html="datails?.advantage"></div>
				</div>
			</div>
			<div class="content video" v-if="datails?.vide_path">
				<div class="title small">产品应用视频</div>
				<div class="valueContent videobox" v-for="(item, index) in datails?.vide_path" :key="index">
					<!-- <video :src="item?.url" :poster="item?.path" :autoplay="false" :controls="false" :loop="false" playsinline @click="lockVideo(item?.url, item, index)"></video> -->
					<img :src="item?.path" class="cover" @click="lockVideo(item?.url, item, index)" />
					<img src="@/assets/images/play_2.png" class="play" @click.stop="lockVideo(item?.url, item, index)" />
				</div>
				<!-- <div v-if="!datails.vide_path" class="empty">{{ loading ? '加载中...' : '暂无内容' }}</div> -->
			</div>
			<float-btn></float-btn>
		</div>
	</div>
</template>

<script>
import { Toast, Empty } from 'vant';
import Crypt from '@bluedot-tech/vue-ui/es/utils/crypt';
import config from '../config/config';
import NavBar from '@/components/NavBar.vue';
import floatBtn from '@/components/FloatBtn.vue';
export default {
	components: {
		floatBtn,
		[Empty.name]: Empty,
		NavBar
	},
	data() {
		return {
			datails: {},
			loading: true
		};
	},
	mounted() {
		// 页面浏览 监测
		this.$dataStatistics({ page_title: '产品简介' });
		this.initShare();
		this.getDetails();
	},
	methods: {
		getDetails() {
			this.loading = true;
			this.$http.get(`/api/platform/module/${this.$route.query?.id}?filter[type]=3`).then((res) => {
				console.log(res?.data);
				this.datails = res?.data || {};
				this.loading = false;
				this.scoreAdd(this.datails?.id);
			});
			// this.$http.get(`/api/platform/module?filter[type]=3&filter[s_type]=${this.$route.query?.navId}`).then((res) => {
			// 	console.log(res?.data);
			// 	this.datails = res.data?.filter((item) => item?.id == this.$route.query?.id)[0];
			// 	this.loading = false;
			// });
		},
		scoreAdd(moduleid) {
			return new Promise((resolve, reject) => {
				//加积分
				const data = { moduleid: moduleid };
				this.$http
					.post('/api/platform/user/score', data)
					.then((res) => {
						console.log('res', res);
						if (res?.data?.errcode) {
							reject();
						}
						resolve();
					})
					.catch((err) => {
						reject();
					});
			});
		},
		lockVideo(url, item, index) {
			if (!url) return;

			this.$dataStatistics({ event_type: 'click', page_title: '产品简介' }, '观看视频');

			// this.playVedio(url);
			this.$router.push({ path: '/video', query: { video: encodeURIComponent(url) } });
		}
	}
};
</script>
<style lang="less" scoped>
.home {
	background: rgba(249, 247, 243, 0.66);

	.title {
		padding-left: 30px;
		font-weight: bold;
		font-size: 40px;
		color: @theme;
		line-height: 56px;
		position: relative;
		white-space: pre-wrap;
		word-wrap: break-word;
		word-break: break-word;

		&::before {
			content: '';
			display: block;
			position: absolute;
			top: 0;
			left: 0;
			transform: translateY(calc((56px - 40px) / 2));
			z-index: 1;
			width: 10px;
			height: 42px;
			// border-radius: 5px;
			background: @theme;
		}

		&.small {
			font-size: 32px;
			line-height: 1;

			&::before {
				width: 6px;
				height: 30px;
				// border-radius: 3px;
				top: 50%;
				transform: translateY(-50%);
			}
		}
	}

	.line {
		clear: both;
		display: block;
		border-bottom: 1.5px dashed @theme;
		margin: 36px;
	}

	.content {
		margin: 40px auto 32px;
		width: calc(828px - 36px - 36px);
		padding: 40px 0;
		position: relative;
		overflow: hidden;
		height: auto;
		z-index: 6;
		background: #ffffff;
		border-radius: 10px;
		box-shadow: 0px 0 12px 6px rgba(0, 0, 0, 0.04);
		clear: both;

		.videobox {
			margin-top: 36px;
		}

		&.video {
			padding-top: 30px;
		}

		.valueContent {
			position: relative;
			padding: 0 30px;
			// background: rgba(255, 255, 255, 0.6);
			// box-shadow: 0px -9px 65px 0px rgba(0, 0, 0, 0.13);
			white-space: pre-wrap;
			word-wrap: break-word;
			word-break: break-all;

			&:first-child {
				padding-top: 0;
			}

			/deep/img,
			img {
				max-width: 100%;
			}

			.play {
				width: 80px;
				height: 80px;
				display: block;
				position: absolute;
				top: 50%;
				left: 50%;
				transform: translateX(-50%) translateY(-50%);
				z-index: 333;
			}
		}
	}
}
</style>
